import React, { useContext, useEffect, useState } from 'react';
import LayoutContext from 'context/layout';

import { Container } from 'styles';
import { changeCssVariable, setUrlCategoryType } from 'utils/appUtils';
import * as S from './styles';
import FaqService from 'services/faqService';

const MainSearch = () => {
    const { state } = useContext(LayoutContext);
    const [articles, setArticles] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        changeCssVariable('--main-search-height', (state.isHome ? '250px' : '125px'))
	}, [state]);

    const searchArticles = (term) => {
        setSearchTerm(term);

        if (!term) {
            setArticles([]);
            setShowResults(false);
            return;
        }
        const payload = { title: term };
        FaqService.getArticles({}, payload)
            .then(({ data }) => {
                setArticles(data.content);
                setShowResults(true);
            })
    }

    const clearInput = () => {
        setTimeout(() => {
            setShowResults(false);
            setSearchTerm(() => '');
        }, 200);
    }

	return (
		<S.MainSearchWrapper display={state.displaySearch}>
			<Container>
                <S.MainSearchContent>
                    <S.MainSearchText isHome={state.isHome}>Como podemos te ajudar?</S.MainSearchText>


                    <S.MainSearch isHome={state.isHome}>
                        <S.MainSearchInput
                            placeholder="Escreva sua dúvida"
                            debounceTimeout={700}
                            minLength={3}
                            value={searchTerm}
                            onChange={$event => searchArticles($event.target.value)}
                            onBlur={clearInput}
                        />
                        <S.MainSearchIcon>
                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.34252 0C7.91866 0 9.43025 0.62612 10.5448 1.74062C11.6593 2.85512 12.2854 4.36671 12.2854 5.94286C12.2854 7.41486 11.7459 8.768 10.8591 9.81029L11.1059 10.0571H11.8282L16.3997 14.6286L15.0282 16L10.4568 11.4286V10.7063L10.2099 10.4594C9.16766 11.3463 7.81452 11.8857 6.34252 11.8857C4.76637 11.8857 3.25478 11.2596 2.14028 10.1451C1.02578 9.03059 0.399658 7.519 0.399658 5.94286C0.399658 4.36671 1.02578 2.85512 2.14028 1.74062C3.25478 0.62612 4.76637 0 6.34252 0ZM6.34252 1.82857C4.0568 1.82857 2.22823 3.65714 2.22823 5.94286C2.22823 8.22857 4.0568 10.0571 6.34252 10.0571C8.62823 10.0571 10.4568 8.22857 10.4568 5.94286C10.4568 3.65714 8.62823 1.82857 6.34252 1.82857Z" fill={process.env.REACT_APP_COLOR_MAIN}/>
                            </svg>
                        </S.MainSearchIcon>
                        <S.MainSearchResults style={{display: (showResults ? 'block' : 'none')}}>
                            {articles.map(article => (<S.ResultLink key={article.id} to={`/artigo/${setUrlCategoryType(article.categoryType.toLowerCase())}/${article.url}`}>{article.title}</S.ResultLink>))}
                            {articles.length === 0 && (<S.ResultEmpty>Nenhum artigo encontrado</S.ResultEmpty>)}
                        </S.MainSearchResults>
                    </S.MainSearch>
                </S.MainSearchContent>
			</Container>
		</S.MainSearchWrapper>
	);
}

export default MainSearch;